        <div class="footer">
            <p class="copyright">Copyright © 2021 <strong class="theme-text-color">Wallet App</strong> All Rights Reserved.</p>
        </div>

        